import React from "react";
import { Select, Spin } from "antd";

/**
 * The "Select Policy" control at the top of every insurance-modal tab.
 *
 * Breakdowns, Estimates and Claims each start with the same question — which of
 * the patient's policies are we looking at? — and the Breakdowns and Estimates
 * tabs used to answer it with two copies of the same dropdown, which had already
 * drifted (one rendered "undefined (undefined)" for a policy with no display
 * name). One control, one label rule.
 *
 * Renders the heading, the PMS-fetch spinner and the dropdown; the host keeps
 * its own wrapper (padding, tour anchor) and its own `onChange`, which is where
 * each tab resets the state that depends on the policy.
 *
 * "+ Add New Policy" appears only when the host can actually open that flow.
 */
const ADD_NEW = "__add_new__";

function policyLabel(policy) {
  const name = policy.insurance_name_display || policy.insurance_name || policy.carrier_code || "Unknown";
  return name + (policy.insurance_type_display ? ` (${policy.insurance_type_display})` : "");
}

export default function PolicySelect({
  patientPolicies,
  value,
  onChange,
  onRequestAddPolicy,
  // True while policies are being auto-fetched from the PMS for a no-policy
  // patient; the dropdown says so instead of looking empty.
  isFetchingPolicies,
}) {
  const options = [];
  if (onRequestAddPolicy) {
    options.push({
      value: ADD_NEW,
      label: <div style={{ color: "#6b43b5", fontWeight: 600 }}>+ Add New Policy</div>,
    });
  }
  (patientPolicies || []).forEach(function (policy) {
    options.push({
      value: policy.id,
      label: <div className="policy-opt-label">{policyLabel(policy)}</div>,
    });
  });

  return (
    <>
      <p style={{ margin: "0 0 10px 0", color: "#848696", fontWeight: 500 }}>Select Policy</p>
      {isFetchingPolicies && (
        <div style={{ display: "flex", alignItems: "center", gap: 8, margin: "0 0 10px 0", color: "#6b43b5", fontSize: 12 }}>
          <Spin size="small" /> Fetching policies from the PMS…
        </div>
      )}
      <Select
        loading={isFetchingPolicies}
        options={options}
        onChange={function (next) {
          if (next === ADD_NEW) {
            onRequestAddPolicy();
            return;
          }
          onChange(next);
        }}
        value={value}
        placeholder="Select Policy"
        style={{ width: "100%" }}
      />
    </>
  );
}
